import { render, staticRenderFns } from "./ProsumerDeclaration.vue?vue&type=template&id=0fb1cbc0&scoped=true"
import script from "./ProsumerDeclaration.vue?vue&type=script&lang=ts"
export * from "./ProsumerDeclaration.vue?vue&type=script&lang=ts"
import style0 from "./ProsumerDeclaration.vue?vue&type=style&index=0&id=0fb1cbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1cbc0",
  null
  
)

export default component.exports